import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { BaseVoltageService } from '../../../services/base-voltage.service';
import { ToastrService } from 'ngx-toastr';
import { BaseVoltage } from '../../../models/base-voltage.model';
import { Voltage } from '../../../enums/voltage';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
  selector: 'lib-nec-base-voltage',
  templateUrl: './nec-base-voltage.component.html',
  styleUrls: ['./nec-base-voltage.component.scss', '../network-entity-classes.component.scss'],
  standalone: false
})
export class NecBaseVoltageComponent {
  currentPage: number = 1;
  pageSize: number = 10;
  pageSizes = [10, 20];

  searchDropdownOpened: boolean = false;
  filterOpened: boolean = false;
  voltages: BaseVoltage[] = [];
  count: number = 0;
  Voltage = Voltage;
  newInstance: BaseVoltage = new BaseVoltage();
  colorPickerOpened: boolean = false;
  isEdit: boolean = false;
  actionMenuOpenForId: number | null = null;

  @ViewChild('colorPickerModal') colorPickerRef?: ElementRef;
  @ViewChild('closeEditModal') closeEditModal!: ElementRef;

  constructor(
    private baseVoltageService: BaseVoltageService,
    private toastr: ToastrService,
    public permissionsService: PermissionsService) { }

  ngOnInit(): void {
    this.getAll()
  }

  private getAll() {
    this.currentPage = 1;
    this.getPage();
  }

  refresh() {
    this.getAll();
  }

  toggleMenu(voltage: any, event: MouseEvent) {
    event.stopPropagation();
    this.newInstance = new BaseVoltage({ ...voltage });
    this.actionMenuOpenForId = this.actionMenuOpenForId === voltage.id ? null : voltage.id;
  }

  selectBaseVoltage(voltage: BaseVoltage) {
    this.newInstance = new BaseVoltage({ ...voltage });
    this.isEdit = true;
  }
  
  onPageChange(page: number) {
    this.currentPage = page;
    this.getPage();
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.getAll();
  }

  private getPage() {
    const dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      }
    };

    this.baseVoltageService.getAll(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.voltages = responseData?.data?.data?.map((el: any) => new BaseVoltage(el)) ?? [];
          this.count = responseData.data.count ?? this.count;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => this.toastr.error('Error occurred')
    });
  }

  openCreateModal() {
    this.resetForCreate();
    this.isEdit = false;
  }

  resetForCreate() {
    this.newInstance = new BaseVoltage();
    this.newInstance.colorCode = '00859C';
  }

  saveInstance(item: BaseVoltage) {
    if (
      this.newInstance.nominalVoltage === null ||
      this.newInstance.nominalVoltage === undefined ||
      isNaN(Number(this.newInstance.nominalVoltage)) ||
      Number(this.newInstance.nominalVoltage) <= 0
    ) {
      this.toastr.warning("Nominal voltage must be a positive number!");
      return;
    }

    if (!this.newInstance.voltageClass) {
      this.toastr.warning("Voltage class must be selected!");
      return;
    }


    this.baseVoltageService.createOrUpdate(item).subscribe({
      next: (response) => {
        const res = response.body;
        if (res?.status === 'OK' || res?.status === 200) {
          this.toastr.success('Base Voltage saved successfully');
          this.closeEditModal?.nativeElement?.click();
          this.refresh();
        } else {
          this.toastr.error(res?.message || 'Error occurred');
        }
      },
      error: () => this.toastr.error('Error occurred while saving')
    });
  }

  confirmDelete() {
    if (!this.newInstance) return;

    this.baseVoltageService.delete(this.newInstance.id).subscribe({
      next: (response: any) => {
        const res = response.body;
        if (res?.status === 200 || res?.status === 'OK') {
          this.toastr.success('Deleted successfully');
          this.refresh();
        } else {
          this.toastr.error(res?.message || 'Delete failed');
        }
      },
      error: () => this.toastr.error('Error occurred while deleting')
    });
  }

  toggleColorPicker(event: MouseEvent) {
    event.stopPropagation();
    this.colorPickerOpened = !this.colorPickerOpened;
  }

  onColorChange(event: any) {
    const hex: string = event.color.hex.slice(1).toLocaleUpperCase();
    this.newInstance.colorCode = hex;
  }

  updateVoltageFields() {
    this.newInstance.nominalVoltage = Number(this.newInstance.nominalVoltage);

    if (this.newInstance.nominalVoltage > 0) {
      this.newInstance.name = `${this.newInstance.nominalVoltage}`;
    } else {
      this.newInstance.name = '';
    }
  }

  @HostListener('document:click')
  closeMenu() {
    if (this.actionMenuOpenForId !== null) {
      this.actionMenuOpenForId = null;
    }
    if (!this.colorPickerOpened) return;
    this.colorPickerOpened = false;
  }
}
